import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { useAuthStore } from '@/store/authStore';

export function useTenantGovernance() {
  const { role, tenantId, impersonatedTenantId, user } = useAuthStore();
  const tenant = impersonatedTenantId ?? tenantId;
  const enabled = !!tenant && ['tenantadmin', 'support', 'superadmin'].includes(role || '');
  const query = useQuery({ queryKey: ['business-governance-settings', tenant, user?.userId], enabled,
    queryFn: async () => (await apiClient.get<{ governanceMode: string }>('/tenant-governance/settings')).data,
    staleTime: 0, refetchInterval: 15000, retry: 1 });
  return { ...query, enabled, ready: !enabled || !!query.data, independent: query.data?.governanceMode === 'independent_businesses' };
}
